import styled from 'styled-components'
import { MenuIconButton } from '@sketch/components'

export const MarkAllCommentsAsReadButton = styled(MenuIconButton)`
  [role='img'] {
    width: 17px;
  }
`

export const AddAnnotationButton = styled(MenuIconButton)`
  [role='img'] {
    width: 17px;
  }
`
